import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../../styles';
import Nav from '../../Navigation/Nav';

const styles = css`
  width: 100%;
  text-align: center;
  position:relative;
  z-index: 6;
  @media (min-width: 992px) {
    padding: 0;
    text-align: center;
    border-bottom: 1px solid ${colors.neutral};
    z-index: 6;
    padding: 0;
  }
  .PageMenu_title {
    width: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${colors.body};
    font-family: ${typography.Serif};
    font-weight: 600;
    font-size: 17px;
    line-height: 1;
    height: 55px;
    padding: 0 30px;
    border-bottom: 1px solid ${colors.neutralDarker};
    @media (min-width: 992px) {
      display: none;
    }
    &::after {
      content: '';
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 6px solid ${colors.brand2};
      position: relative;
      margin: 0 0 0 5px;
    }
  }
  .PageMenu_list {
    padding: 0;
    text-align: left;
    width: calc(100vw - 60px);
    display: none;
    position: absolute;
    left: 30px;
    top: 55px;
    list-style: none;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.25);
    &-active{
      display: block;
    }
    @media (min-width: 992px) {
      position: relative;
      width: auto;
      left: auto;
      margin-left: 0;
      top: auto;
      box-shadow: none;
      text-align: center;
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: relative;
    }
  }
  .PageMenu_listItem {
    @media (min-width: 992px) {
      display: inline-block;
    }
    a {
      background-color: ${colors.white};
      padding: 10px 15px;
      border-bottom: 1px solid ${colors.neutral};
      display: block;
      color: ${colors.body};
      cursor: pointer;
      @media (min-width: 992px) {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;
        height: 80px;
        line-height: 1;
        color: ${colors.brand1Light};
        font-weight: 700;
        letter-spacing: 1px;
        text-align: center;
        padding: 0 15px;
        border: 0;
        font-size: 15px;
        opacity: .5;
        position: relative;
        &.active {
          color: ${colors.brand1};
          opacity: 1;
          &::after {
            content: '';
            display: block;
            position: absolute;
            bottom: 20px;
            left: 50%;
            height: 2px;
            width: calc(100% - 30px);
            transform: translateX(-50%);
            background-color: ${colors.brand3};
          }
        }
      }
    }
  }
`;

function InsideMenu({ content }) {
  return (
    <Nav
      className="InsideMenu"
      toggleSubMenus
      menuId={get(content, '[0].menu')}
      menuProps={{
        className: styles,
        headingClassName: 'PageMenu_title',
        subMenuClassName: 'PageMenu_list',
        subMenuActiveClassName: 'PageMenu_list-active',
        itemClassName: 'PageMenu_listItem',
      }}
    />
  );
}

InsideMenu.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default InsideMenu;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/InsideMenu.section.js